<!-- 마이보드 > 메인 -->
<template>
  <div class="mb-page-wrap">
    <div class="tit-group mo-none">
      <h2 class="tit">{{t('message.myBoard')}}</h2>
    </div>
    <div class="tab-group">
      <v-tabs
        v-model="tab"
      >
        <v-tab value="tabCont1">{{t('message.myCorrectiveAction')}}</v-tab>
        <v-tab value="tabCont2">{{t('message.departmentCorrectiveAction')}}</v-tab>
        <v-tab value="tabCont3">{{t('message.myPraise')}}</v-tab>
        <v-tab value="tabCont4">{{t('message.departmentPraise')}}</v-tab>
      </v-tabs>
    </div>
    <div class="content-box bg-none">
      <v-tabs-window v-model="tab">
        <v-tabs-window-item value="tabCont1">
          <component :is="tabView1 ? MyBoardTabCont11 : MyBoardTabCont1" :tabType="'tabCont1'"/>
        </v-tabs-window-item>
        <v-tabs-window-item value="tabCont2">
          <component :is="tabView1 ? MyBoardTabCont11 : MyBoardTabCont1" :tabType="'tabCont2'"/>
        </v-tabs-window-item>
        <v-tabs-window-item value="tabCont3">
          <component :is="tabView1 ? MyBoardTabCont11 : MyBoardTabCont1" :tabType="'tabCont3'"/>
        </v-tabs-window-item>
        <v-tabs-window-item value="tabCont4">
          <component :is="tabView1 ? MyBoardTabCont11 : MyBoardTabCont1" :tabType="'tabCont4'"/>
        </v-tabs-window-item>
      </v-tabs-window>
    </div>
  </div>
</template>

<script setup lang="ts">

import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useCommonStore } from "@/store/common";
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n';
import MyBoardTabCont1 from "@/components/MyBoard/MyBoardTabCont1.vue";
import MyBoardTabCont11 from "@/components/MyBoard/MyBoardTabCont1-1.vue";
const { t } = useI18n();

//store
const route = useRoute()
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const tab = storeRef.tabName
const tabView1 = storeRef.isTabView1

//hook
onUpdated(() => {
})

//watch
watch(tab, (newData, oldData) => {
  tabView1.value = false
  if(newData != oldData && oldData != '') //초기진입이 아니고 탭이 변경되면 변경된 탭저장
    storeRef.tabName.value = newData
});
</script>



<style lang="scss" scoped>
</style>
